import gql from 'graphql-tag'
import {
    CreateSpace,
    CreateSpaceMutation,
    CreateSpaceMutationVariables,
    SpaceTypeEnum,
    UpdateSpaceMutation,
    UpdateSpaceMutationVariables,
    DeleteSpaceMutation,
    DeleteSpaceMutationVariables,
    UpdateHomeSpaceMutation,
    UpdateHomeSpaceMutationVariables,
} from 'generated/graphql'
import graphql from 'utils/graphql'

// Create space
const createSpaceMutation = gql`
    mutation createSpace($input: CreateSpace!) {
        createSpace(data: $input) {
            id
            slug
        }
    }
`
export const createSpace = (input: CreateSpace) => {
    const query = graphql.createQuery<CreateSpaceMutation, CreateSpaceMutationVariables>(createSpaceMutation)
    return query({ input })
}

const updateSpaceMutation = gql`
    mutation updateSpace($id: ID!,$data: UpdateSpace!) {
        updateSpace(id: $id, data: $data) {
            id
        }
    }
`
export const updateSpaceOrder = (id: string, order: number) => {
    const query = graphql.createQuery<UpdateSpaceMutation, UpdateSpaceMutationVariables>(updateSpaceMutation)
    return query({ id, data: { timetableOrder: order } })
}
export const updateSpacePublished = (id: string, published: boolean) => {
    const query = graphql.createQuery<UpdateSpaceMutation, UpdateSpaceMutationVariables>(updateSpaceMutation)
    return query({ id, data: { published } })
}

const deleteSpaceMutation = gql`
    mutation deleteSpace($data: DeleteSpace!) {
        deleteSpace(data: $data)
    }
`
export const deleteSpace = (id, spaceType?: SpaceTypeEnum) => {
    const mutation = graphql.createQuery<
        DeleteSpaceMutation, DeleteSpaceMutationVariables
    >(deleteSpaceMutation)
    return mutation({ data: { id, type: spaceType } })
}

const updateHomeSpaceMutation = gql`
    mutation updateHomeSpace ($eventSlug: EventID!, $data: UpdateEventInput!) {
        updateEvent(event: $eventSlug, data: $data) {
            id
        }
    }
`
export const updateHomeSpace = (eventSlug, homeSpaceId) => {
    const mutation = graphql.createQuery<
        UpdateHomeSpaceMutation, UpdateHomeSpaceMutationVariables
    >(updateHomeSpaceMutation)
    return mutation({
        eventSlug,
        data: {
            virtual: {
                homeSpaceId
            }
        }
    })
}
